//library
import { useMemo, useState, useCallback, useEffect } from "react";

import useWindowSize from "hooks/use-window-size";

//components
import AppNavbar from "components/app-navbar";
import HeaderCard from "components/app-header-card";
import AppPagination from "components/app-pagination";

import headerImage from "assets/images/pages/page-products/products-bg.jpg";
import AppProductCard from "components/app-product-card";

import AtfProductsWithVideoThumbnail from "assets/images/pages/page-products/atf-products-with-video-thumbnail.jpg";
import AtfProductsThumbnail from "assets/images/pages/page-products/atf-products-thumbnail.jpg";
import AppFooter from "components/app-footer";

const PageProductsWithPricing = () => {
	const sizes = useWindowSize();
	const [currentPage, setCurrentPage] = useState(0);
	const isMobileView = useMemo(() => (sizes?.[0] <= 489 ? true : false), [sizes]);
	const content = useMemo(() => {
		return [
			{
				title: "AI Financial Planner (Wealth Management)",
				description: "Customer Web, Admin Back-office Portal",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-Wealth-Management-System.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/WMS-Thumbnail.jpg",
				priceWithCode: "$1.5M USD",
				price: "$500K USD",
			},
			{
				title: "E-Invoice",
				description: "Customer Responsive Web, Admin Back-office Portal",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-E-Invoice.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/E-Invoice-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "Work Order Management System",
				description: "Customer Mobile App, Admin Back-office Portal​",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-Work-Order-Management-System.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/WOMS-Thumbnail.jpg",
				priceWithCode: "$300K USD",
				price: "$100K USD",
			},
			{
				title: "Content Management System + e-Commerce (Lite)",
				description: "Website, Buyer Web, Seller Web, Admin Back-office Portal​",
				videoUrl: "https://cdn.directintegrate.com/directintegrate/media/video/ATF-E-Commerce-Lite-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-E-Commerce-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/CMS_Lite-Thumbnail.jpg",
				priceWithCode: "-",
				price: "$10K USD",
			},
			{
				title: "Content Management System + e-Commerce (Full Suite)",
				description: "Website, Buyer App, Seller App, Buyer Web, Seller Web, Admin Back-office Portal​",
				videoUrl: "https://media.directintegrate.com/altecflex/video/ATF-E-commerce-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-E-Commerce-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/CMS_Suite-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "Retail Business Management System",
				description: "Customer Web, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF-RBMS-Video_V2.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/RBMS-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "Insurance Brokerage Management System",
				description: "Agent Web, Admin Back-office Portal, SFTP",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF General Insurance Admin Portal Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF_IMS_Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/IBMS-Thumbnail.jpg",
				priceWithCode: "$1.5M USD",
				price: "$500K USD",
			},
			{
				title: "Financial App with MLM",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Financial-app-Thumbnail.jpg",
				priceWithCode: "$750K USD",
				price: "$300K USD",
			},
			{
				title: "Super-app",
				description: "Mobile App, Customer Back-office Portal, Admin Back-office Portal, SFTP",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_Super-app.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Super-app-Thumbnail.jpg",
				priceWithCode: "$700K USD",
				price: "$280K USD",
			},
			{
				title: "Task & Project Management",
				description: "Customer Web",
				videoUrl: "https://cdn.directintegrate.com/directintegrate/media/video/ATF-Task%20Management-Platform-Video.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Workflow-Management-Platform-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/TaskProject-Thumbnail.jpg",
				priceWithCode: "$200K USD",
				price: "$40K USD",
			},
			{
				title: "InsureBridge – Motor Insurance Edition",
				description: "Open API, Customer Web",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/InsureBridge-Thumbnail.jpg",
				priceWithCode: "$300K USD",
				price: "$100K USD",
			},
			{
				title: "e-Ticketing Solution (Mobile Responsive)",
				description: "Customer Web, Staff Portal, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_E-Ticketing-Solution.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/E-Ticket-Thumbnail.jpg",
				priceWithCode: "$80K USD",
				price: "$20K USD",
			},
			{
				title: "Loyalty App",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Loyalty-app-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "SanctionGuard",
				description: "Open API",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF-SanctionGuard.mp4",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Sanction-Flyer.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/SanctionGuard-Thumbnail.jpg",
				priceWithCode: "$30K USD",
				price: "$10K USD",
			},
			{
				title: "Loan Onboarding System",
				description: "Customer Mobile App, Admin Back-office Portal",
				videoUrl: "",
				link: "https://media.directintegrate.com/directintegrate/cms/brochure/ATF-Microloan-Brochure.pdf",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Loan-Onboarding-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "HR Portal",
				description: "Staff Portal, Admin Back-office Portal",
				videoUrl: "http://cdn.directintegrate.com/directintegrate/media/video/ATF_HRMS.mp4",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/HR-Portal-Thumbnail.jpg",
				priceWithCode: "$120K USD",
				price: "$40K USD",
			},
			{
				title: "Test Automation Framework",
				description: "Automation Framework Base (exclusive incremental module coverage)",
				videoUrl: "",
				link: "",
				image: "http://cdn.directintegrate.com/directintegrate/media/Product-list/Test_Automation-Thumbnail.jpg",
				fixedPrice: "Find out more with us",
			},
		];
	}, []);

	const totalPageNumber = Math.ceil(content.length / 6);
	const displayItems = isMobileView ? content.slice(currentPage * 6, (currentPage + 1) * 6) : content;

	const onHandleNext = useCallback(() => {
		setCurrentPage((prev) => (prev + 1) % totalPageNumber);
	}, [totalPageNumber]);

	const onHandleBack = useCallback(() => {
		setCurrentPage((prev) => (prev - 1 + totalPageNumber) % totalPageNumber);
	}, [totalPageNumber]);

	useEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [currentPage]);

	return (
		<div className="page-products-with-pricing">
			<div className="products-with-pricing">
				<AppNavbar hideNavBar />

				<HeaderCard backgroundImage={headerImage} title="PRODUCT PRICING" />

				<div className="products-with-pricing__wrapper">
					<div className="products-with-pricing__container">
						{displayItems?.map((o, i) => (
							<div className="products-with-pricing__box" key={i}>
								<AppProductCard image={o.image} title={o.title} description={o.description} link={o.link} key={i} videoUrl={o.videoUrl} price={o.price} priceWithCode={o.priceWithCode} fixedPrice={o.fixedPrice} />
							</div>
						))}
					</div>
				</div>

				<div className="products-with-pricing__section">
					<p className="products-with-pricing__disclaimer">
						<span className="products-with-pricing__title">Disclaimer: </span>

						<span>All Product prices are subject to periodic review and may be adjusted at the company’s discretion.</span>
					</p>
				</div>

				{isMobileView && (
					<div className="products-with-pricing__mobile-pagination">
						<AppPagination totalPageNumber={totalPageNumber} currentPage={currentPage} onHandleNext={onHandleNext} onHandleBack={onHandleBack} />
					</div>
				)}

				<AppFooter hideInfo />
			</div>
		</div>
	);
};

export default PageProductsWithPricing;
